// frontend/pages/ServicesSection.js
import React from 'react';
import { Car, Wrench, Shield, Users, Settings, TrendingUp, DollarSign } from 'lucide-react';

const features = [
  {
    icon: <Car className="h-7 w-7 text-blue-400" />,
    title: 'Pour les propriétaires',
    desc: 'Gestion simplifiée de l’entretien, rappels d’assurance, historique et alertes personnalisées.'
  },
  {
    icon: <Users className="h-7 w-7 text-violet-400" />,
    title: 'Pour les flottes',
    desc: 'Suivi centralisé de tous les véhicules, alertes, coût total de possession et analyse prédictive.'
  },
  {
    icon: <Wrench className="h-7 w-7 text-yellow-400" />,
    title: 'Pour les ateliers',
    desc: 'Nouveaux clients qualifiés, historique digital des interventions, gestion des paiements facilitée.'
  },
  {
    icon: <Settings className="h-7 w-7 text-indigo-400" />,
    title: 'Pour les fournisseurs',
    desc: 'Connexion directe avec les ateliers et propriétaires, commandes simplifiées et visibilité accrue.'
  },
  {
    icon: <Shield className="h-7 w-7 text-green-400" />,
    title: 'Pour les assureurs',
    desc: 'Accès à l’historique des réparations, validation des sinistres et automatisation des démarches.'
  },
  {
    icon: <TrendingUp className="h-7 w-7 text-pink-400" />,
    title: 'Technologie & IA',
    desc: 'Maintenance prédictive, recommandations personnalisées et optimisation des coûts.'
  },
];

const ServicesSection = () => (
  <section className="min-h-screen bg-[#181d28] flex items-center justify-center py-16 px-4">
    <div className="max-w-4xl w-full mx-auto bg-[#1f2230] rounded-xl shadow-2xl p-10 text-white space-y-8">
      <h2 className="text-3xl font-extrabold flex items-center gap-3">
        <DollarSign className="h-8 w-8 text-blue-500" />
        Nos Services
      </h2>
      <p className="text-lg text-blue-100">
        Nous simplifions la gestion de l’entretien, de l’assurance et des réparations pour les propriétaires de véhicules et les flottes d’entreprise. Notre plateforme connecte ateliers, fournisseurs et prestataires de services de confiance, garantissant transparence, prix justes et commissions sécurisées pour nos partenaires.
      </p>
      <p className="text-lg text-blue-100">
        Grâce à la technologie avancée et aux analyses prédictives basées sur l’IA, nous anticipons les besoins de chaque véhicule avant qu’ils ne deviennent des problèmes coûteux. Nous aidons les propriétaires à planifier l’entretien préventif, à suivre les renouvellements d’assurance et à obtenir les bonnes pièces au bon moment.
      </p>
      <p className="text-lg text-blue-100">
        Nous ne sommes pas seulement un intermédiaire – nous sommes l’écosystème qui rend la gestion automobile plus intelligente, plus rapide et plus fiable pour tous les acteurs du secteur.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 pt-4">
        {features.map((f, i) => (
          <div
            key={i}
            className="bg-[#202435] rounded-lg p-6 shadow-lg flex flex-col items-start gap-4 min-h-[170px] hover:scale-105 transition"
          >
            {f.icon}
            <div className="font-semibold text-lg text-white">{f.title}</div>
            <div className="text-sm text-blue-200">{f.desc}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ServicesSection;
